export const MultiSelectSingleLineStyles = (isDarkMode: boolean) => ({
  control: (styles: any, state: any) => ({
    ...styles,
    display: 'flex',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    flexWrap: 'nowrap', // ✅ Prevents wrapping
    backgroundColor: isDarkMode ? '#262A2F' : '#fff',
    borderColor: state.isFocused
      ? isDarkMode
        ? '#fff'
        : '#b0c4de'
      : isDarkMode
      ? '#262A2F'
      : '#ddd',
    boxShadow: state.isFocused
      ? isDarkMode
        ? '0 0 5px rgba(255, 255, 255, 0.5)'
        : '0 0 5px rgba(0, 0, 255, 0.2)'
      : styles.boxShadow,
    transition: 'border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
    '&:hover': {
      borderColor: isDarkMode ? '#fff' : '#b0c4de',
      boxShadow: isDarkMode
        ? '0 0 5px rgba(255, 255, 255, 0.5)'
        : '0 0 5px rgba(0, 0, 255, 0.2)',
    },
    outline: 'none',
  }),

  option: (styles: any, state: any) => ({
    ...styles,
    overflow: 'hidden',
    flexWrap: 'wrap',
    backgroundColor: state.isFocused ? '#4bb189' : 'transparent',
    color: isDarkMode ? '#ffffff' : '#000000',
    padding: 10,
    ':hover': {
      color: '#fff',
    },
  }),

  valueContainer: (styles: any) => ({
    ...styles,
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'nowrap', // ✅ Prevents wrapping
    overflowX: 'auto', // ✅ Enables horizontal scrolling
    whiteSpace: 'nowrap', // ✅ Ensures inline display
    maxWidth: '100%',
    scrollbarWidth: 'thin', // ✅ Thin scrollbar
    '::-webkit-scrollbar': {
      height: '2px', // ✅ Thin scrollbar height
    },
    '::-webkit-scrollbar-thumb': {
      background: '#ccc',
      borderRadius: '2px',
    },
    '::-webkit-scrollbar-thumb:hover': {
      background: '#999',
    },
  }),

  multiValue: (styles: any) => ({
    ...styles,
    backgroundColor: '#3762ea',
    borderRadius: '15px',
    // margin: '2px',
    whiteSpace: 'nowrap', // ✅ Keeps items inline
    flexShrink: 0, // ✅ Prevents squeezing when overflowed
  }),

  multiValueLabel: (styles: any) => ({
    ...styles,
    backgroundColor: '#4bb189',
    borderRadius: '15px 0 0 15px',
    color: 'white',
    whiteSpace: 'nowrap',
  }),

  multiValueRemove: (styles: any) => ({
    ...styles,
    color: 'white',
    backgroundColor: '#4bb189',
    borderRadius: '0 15px 15px 0',
    ':hover': {
      backgroundColor: '#4bb189',
      color: '#333',
    },
  }),

  clearIndicator: (styles: any) => ({
    ...styles,
    color: '#888',
    cursor: 'pointer',
    ':hover': {
      color: 'red',
    },
  }),

  input: (styles: any) => ({
    ...styles,
    color: isDarkMode ? '#ffffff' : '#000000',
  }),

  indicatorsContainer: (styles: any) => ({
    ...styles,
    whiteSpace: 'nowrap', // ✅ Keeps clear and dropdown buttons aligned
  }),
});
